import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageView } from "./ga";

// Human-friendly titles per route so GA sees meaningful page_title values.
const TITLES = {
  "/dashboard":         "Dashboard · FIJ Terminal",
  "/events":            "Financial Journal · FIJ Terminal",
  "/financial-journal": "Financial Journal · FIJ Terminal",
  "/stocks":            "Stock Analysis · FIJ Terminal",
  "/stock-analysis":    "Stock Analysis · FIJ Terminal",
  "/morning-brief":     "Morning Brief · FIJ Terminal",
  "/settings":          "Settings · FIJ Terminal",
  "/login":             "Sign In · FIJ Terminal",
  "/signup":            "Sign Up · FIJ Terminal",
  "/privacy":           "Privacy Policy · FIJ Terminal",
  "/terms":             "Terms & Conditions · FIJ Terminal",
  "/contact":           "Contact · FIJ Terminal",
};

function titleFor(pathname) {
  if (TITLES[pathname]) return TITLES[pathname];
  if (pathname.startsWith("/events/")) return "Event Details · FIJ Terminal";
  return "FIJ Terminal";
}

/**
 * Mount inside <BrowserRouter>. Boots GA once and fires a `page_view` on every
 * SPA route change (including the first).
 */
export function GAListener() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => { initGA(); }, []);

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    // De-dupe: React.StrictMode double-invokes effects in dev and browsers
    // occasionally emit repeated location events. Only fire once per path.
    if (lastPath.current === path) return;
    lastPath.current = path;
    // Defer one frame so react-helmet-async has a chance to update
    // <title> before we snapshot it for the GA page_view event.
    const raf = requestAnimationFrame(() => {
      const title = (typeof document !== "undefined" && document.title) || titleFor(location.pathname);
      trackPageView(path, title);
    });
    return () => cancelAnimationFrame(raf);
  }, [location.pathname, location.search]);

  return null;
}
